import {Box} from "@chakra-ui/react"
import H1 from "./H1"
const Home=()=>{
    return(<>
    <Box width="70%" margin="auto"  marginTop="-120px">
        <H1/>
    </Box>
    </>

    )
}
export default Home